<!-- 新闻资讯 -->
<template>
    <div class="news_wrapper">
        <div class="section_item news_section1 platform_section1">
            <div class="wrapper">
                <div class="block">
                    <div class="title">{{section1.title}}</div>
                    <div class="description">{{section1.description}}</div>
                </div> 
                <img :src="section1.link" alt="">
            </div>
        </div>
        <div class="section_item news_section2">
            <div class="card_wrapper">
                <div v-for="(item, idx) in news_list_show" 
                    :key="idx"
                    class="card_item"
                    @click="bind_jump_content(item)">
                    <div class="img"><img :src="item.link" alt=""></div>
                    <div class="desc_wrapper">
                        <div class="title">{{item.title}}</div>
                        <div class="description">{{item.description}}</div>
                        <div class="date">{{item.date}}</div>
                    </div>
                </div>
            </div>
            <el-button 
                @click='bind_getMore'
                type="warning" 
                class="more btn_init">查看更多新闻</el-button> 
        </div>
        <div class="section_item news_section3">
            <div class="form_wrapper">
                <CmsForm/>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/news.js';
    import constant from '@/util/constant';
    export default {
        name: "Index",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            section1() {
                return data && data.section1;
            },
            section2() {
                return data && data.section2;
            },
            // news_list() {
            //     return data && data.section2.data;
            // }
        },
        data() {
            return {
                // 展示的卡片列表
                news_list_show: [],
                // 选择的投放行业
                val_industry: '',
                // 选择的投放目的
                val_purpose: ''
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // vm.bind_update_scroll();
                // 由于首页可以直接通往案例详情页，所以后退时候需要定位到首页中轮播图的位置
                if (from.path.indexOf('news_content') > -1) {
                    setTimeout(() => {
                        let scrollT = localStorage.getItem('scrollT');
                        window.scrollTo(0, scrollT);
                        localStorage.removeItem('scrollT');
                    }, 500)
                }
            });
        },
        mounted() {
            this.$http.get(`${constant.CMS_ADS}/dsp/ow_news.json?1`).then((res) => {
                this.news_list = res.data.filter((item) => {
                    return item.article_id;
                });
                 // 初始化需要展示的案例
                this.news_list_show = 
                    this.news_list.length >=9 ? 
                    (this.news_list.slice(0, 9)): 
                    (this.news_list.slice(0));
            })
        },
        methods: {
            // 获取更多案例
            bind_getMore() {
                // 百度统计
                // window._hmt.push(['_trackEvent', 'news', 'more']);
                let ori_len = this.news_list_show.length;
                let total_len = this.news_list.length;
                if (total_len > ori_len) {
                    // 如果已有案例数量大于已展示案例数量，则展示数量+3
                    this.news_list_show = this.news_list_show.concat(this.news_list.slice(ori_len, ori_len+3));
                } else {
                    this.$message({
                        message: '已经没有啦',
                        center: true,
                        type: 'error',
                        customClass: 'msg_center',
                        duration: 1000
                    })
                }
            },
            // 获取具体文章内容
            bind_jump_content(item) {
                // 记录这个滚动距离
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                localStorage.setItem('scrollT', scrollTop);
                // 百度统计
                window._hmt.push(['_trackEvent', 'news_detail', JSON.stringify(item)]);
                this.$router.push({
                    path: `news_content/${item.article_id}`
                })
            }
        }
    }
</script>

<style scoped>
    /* 整个首页的包裹样式 */
    .news_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
        font-size: 0;
    }
    /* 第一部分的样式 */
    .news_section1 {
        background: linear-gradient(0deg, #f5f9ff 0%, #fcfdff 100%);
        background: #fcfdff\9\0;
    }
     /* 第二部分的样式 */
    .news_section2 {
        background: #f7f8fa;
        height: auto;
    }
    /* 列表包裹狂 */
    .news_section2 .card_wrapper {
        width: 1280px;
        font-size: 0;
        margin: 31px auto 0 auto;
        overflow: hidden;
    }

    .card_wrapper .card_item {
        float: left;
        width: 400px;
        height: 400px;
        background: #fff;
        border-radius: 4px;
        margin: 0 40px 41px 0;
        cursor: pointer;
        text-align: left;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
        /* animation: shine 0.5s linear; */
        transition: 0.2s linear all;
    }

    .card_wrapper .card_item:hover {
        /* animation: float 0.2s linear forwards; */
        transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        opacity: 0.8;
    }

    .card_wrapper .card_item:nth-child(3n) {
        margin-right: 0px;
    }

    .card_item .img {
        height: 213px;
    }

    .card_item .desc_wrapper {
        padding: 0 24px;
    }

    .card_item .title {
        margin-top: 32px;
        font-size: 18px;
        color: #292C33;
        line-height: 26px;
    }

    .card_item .description {
        margin-top: 16px;
        font-size: 14px;
        color: #AAADB3;
        line-height: 24px;
    }

    .card_item .date {
        margin-top: 16px;
        font-size: 12px;
        color: #BEBFC1;
        line-height: 18px;  
    }

    .news_section2 .more {
        margin-bottom: 40px;
    }
    /* 标题包裹狂 */
    .news_section3 .form_wrapper {
        width: 1280px;
        margin: 0 auto;
        margin-top: 48px;
        margin-bottom: 54px;
    }

</style>





// WEBPACK FOOTER //
// src/containers/News/News.vue